// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "HomeView" + "." + "1c9ca9c0" + ".css";
};